import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Linkedin, Twitter, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-eclipse-surface border-t border-white/5" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="space-y-4">
            <img
              src="https://customer-assets.emergentagent.com/job_freelance-hub-570/artifacts/3r30mrpu_EclipseProfessionalsLogo.png"
              alt="EclipseProfessionals"
              className="h-12 w-auto"
              data-testid="footer-logo"
            />
            <p className="text-eclipse-secondary text-sm leading-relaxed">
              Excellence happens when strategy, creativity, and execution align perfectly.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="text-eclipse-secondary hover:text-brand-cyan transition-colors"
                data-testid="social-linkedin"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="#"
                className="text-eclipse-secondary hover:text-brand-cyan transition-colors"
                data-testid="social-twitter"
                aria-label="Twitter"
              >
                <Twitter size={20} />
              </a>
              <a
                href="#"
                className="text-eclipse-secondary hover:text-brand-cyan transition-colors"
                data-testid="social-instagram"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-eclipse-text font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-eclipse-secondary hover:text-brand-cyan transition-colors text-sm"
                  data-testid="footer-about-link"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-eclipse-secondary hover:text-brand-cyan transition-colors text-sm"
                  data-testid="footer-services-link"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/portfolio"
                  className="text-eclipse-secondary hover:text-brand-cyan transition-colors text-sm"
                  data-testid="footer-portfolio-link"
                >
                  Portfolio
                </Link>
              </li>
              <li>
                <Link
                  to="/testimonials"
                  className="text-eclipse-secondary hover:text-brand-cyan transition-colors text-sm"
                  data-testid="footer-testimonials-link"
                >
                  Testimonials
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-eclipse-text font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-sm text-eclipse-secondary">
              <li>Graphic Design & Branding</li>
              <li>Business Consultancy</li>
              <li>Digital Content</li>
              <li>Virtual Support</li>
              <li>E-commerce Assistance</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-eclipse-text font-semibold mb-4">Get in Touch</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-eclipse-secondary text-sm">
                <Mail size={16} className="text-brand-cyan" />
                <span data-testid="footer-email">josh@eclipseprofessionals.org</span>
              </li>
              <li className="flex items-center space-x-2 text-eclipse-secondary text-sm">
                <Phone size={16} className="text-brand-cyan" />
                <span data-testid="footer-phone">+63 935 620 9334</span>
              </li>
            </ul>
            <Link
              to="/contact"
              className="inline-block mt-4 bg-transparent border border-white/20 text-white hover:border-brand-orange hover:text-brand-orange rounded-full px-6 py-2 text-sm transition-all duration-300"
              data-testid="footer-contact-cta"
            >
              Contact Us
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/5 mt-12 pt-8 text-center text-eclipse-secondary text-sm">
          <p data-testid="copyright">
            © {currentYear} EclipseProfessionals. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;